import { HttpClient } from '@angular/common/http';
import { Injectable, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { catchError, map, Observable, tap } from 'rxjs';
import { ApiEndpoints } from '../common/config';

@Injectable({
  providedIn: 'root',
})
export class GooglemapsService {
  constructor(
    private readonly http: HttpClient,
    private readonly sanitizer: DomSanitizer,
  ) {}

  private loaded = false;

  loadGoogleMaps(): Observable<void> {
    return new Observable(observer => {
      if (this.loaded) {
        observer.next();
        observer.complete();
        return;
      }

      // Check if the script is already in the document to avoid duplicates
      if (document.querySelector('script[src*="maps.googleapis.com"]')) {
        this.loaded = true;
        observer.next();
        observer.complete();
        return;
      }

      let propertyName = 'GoogleAPIKeyProvider';
      return this.http
        .get<any>(`${ApiEndpoints.configurations.GetByName}/${propertyName}`)
        .pipe(
          catchError(err => {
            observer.error(
              new Error('Failed to fetch API key: ' + err.message),
            );
            return [];
          }),
          map((res: any) => res.Data.PropertyValue),
          tap((apiKey: string) => {
            const sanitizedApiKey = this.sanitizer.sanitize(
              SecurityContext.NONE,
              apiKey,
            );
            const script = document.createElement('script');
            script.src = `https://maps.googleapis.com/maps/api/js?key=${sanitizedApiKey}&libraries=geometry,places,marker`;
            script.async = true;
            script.defer = true;

            script.onload = () => {
              this.loaded = true;
              if (typeof google !== 'undefined') {
                observer.next();
                observer.complete();
              } else {
                observer.error(
                  new Error('Google Maps API not loaded properly.'),
                );
              }
            };

            script.onerror = error => {
              observer.error(error);
            };

            document.head.appendChild(script);
            observer.next();
            observer.complete();
          }),
        )
        .subscribe();
    });
  }
}
